import type { SalonDayException, StaffProfile } from '../core/types/site'

/**
 * Wie er in de salon behandelt (Instellingen › Team). Sarah staat altijd vooraan
 * (`staffList` vult haar aan). Wordt bijgewerkt door `applySiteSettings`.
 *
 * TODO vóór livegang: "Mila" is een voorbeeldcollega voor de demo, met een gegenereerd
 * voorbeeldportret (docs/BEELDEN.md). Vervang haar door de echte collega of zet haar op gestopt
 * (Instellingen › Team), en pas de salondagen aan (Instellingen › Salondagen).
 */
export const staff: StaffProfile[] = [
  {
    id: 'sarah',
    name: 'Sarah',
    initials: 'S',
    color: 'clay',
    role: 'owner',
    allTreatments: true,
    treatments: [],
    active: true,
    intro: 'Huidtherapeut en oprichter. Alle behandelingen en kuren.',
  },
  {
    id: 'mila',
    name: 'Mila',
    initials: 'M',
    color: 'sage',
    role: 'staff',
    allTreatments: false,
    treatments: ['get-the-red-out', 'vitamine-c-behandeling', 'ibiza-behandeling'],
    active: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e04c0cc0-3768-4acc-80b2-662808e2007d.jpg',
    intro: 'Schoonheidsspecialist, werkt volgens Sarahs protocollen.',
  },
]

/** Losse dagen die afwijken van de vaste week. */
export const salonExceptions: SalonDayException[] = []
